export default __webpack_public_path__ + "static/media/default_product.a8edfb98.svg";